import React from 'react';
import Spinner from './Spinner';

import './index.scss';

const Loading = (): JSX.Element => {
  const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

  return (
    <div className="loading" data-test="loading">
      <h3 className="title">Loading...</h3>
      <Spinner color={isDarkMode ? '#ffffff' : '#053A5A'} />
    </div>
  );
};
export default Loading;
